import React from 'react';
import { ObjectManager } from '../../../concepts/objects';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Tag } from './Tag';

export const ManageTagsView = () => {

    const objects = useResolve(ObjectManager);
    const tags = Array.from(objects.getAll(Tag));

    const types = new Set(tags.map(tag => tag.name));

    return <Flexer>
        {Array.from(types).map(t =>
            <Flexer key={t}>
                {t}
            </Flexer>
        )}
    </Flexer>;
};


// currency-bangladeshi
// currency-dollar
// currency-euro
// currency-pound
// currency-rupee
// currency-yen
// clock
// bell
// hashtag
// heart
// gift
// star
// user
